export default "__VITE_ASSET__9320fcc8__"